// extracted by mini-css-extract-plugin
export default {"tooltip":"TooltipBase_tooltip__wsWKZ","tooltip_content":"TooltipBase_tooltip_content__ohyQf","tooltip_icon":"TooltipBase_tooltip_icon__oj41F"};